import { render, staticRenderFns } from "./ForTraining.vue?vue&type=template&id=1d863d83&scoped=true"
import script from "./ForTraining.vue?vue&type=script&lang=js"
export * from "./ForTraining.vue?vue&type=script&lang=js"
import style0 from "./ForTraining.vue?vue&type=style&index=0&id=1d863d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d863d83",
  null
  
)

export default component.exports